import clearIsDirty from '../../actions/clearIsDirty';
import getAdvertisingOptions from '../../selectors/gdprAdsV3Option/getAdvertisingOptions';
import { getOptionsForFeature } from 'owa-outlook-service-options';
import { orchestrator } from 'satcheljs';
import { saveEmailAdsSelectOptions } from '../../actions/gdprAdsV3/advertisingOptionsActions';
import {
    createOrUpdateOptionsForAdsFeature,
    EUEmailAdsOptions,
    euEmailAdsOwsOptionsFeatureType,
} from 'owa-ads-ows-options';

const saveEmailAdsSelectOptionsOrchestrator = orchestrator(saveEmailAdsSelectOptions, async () => {
    const options = getAdvertisingOptions();

    const savedOptions = getOptionsForFeature<EUEmailAdsOptions>(euEmailAdsOwsOptionsFeatureType);
    const newOptions = {
        ...savedOptions,
        optInBit: options.optInBit,
    };
    clearIsDirty();

    createOrUpdateOptionsForAdsFeature(euEmailAdsOwsOptionsFeatureType, newOptions);
});

export default saveEmailAdsSelectOptionsOrchestrator;
